import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Maincontent from "./Maincontent";
import ExcelImport from "./ExcelImport";
import { Layout, Breadcrumb, Tabs } from "antd";
import { FileExcelOutlined, UnorderedListOutlined } from "@ant-design/icons";

const { TabPane } = Tabs;

// const ExcelImport = () => {
//   return (
//     <div style={{ padding: '20px', textAlign: 'center' }}>
//       <div style={{ marginBottom: '20px' }}>
//         <FileExcelOutlined style={{ fontSize: '48px', color: '#1890ff' }} />
//         <h2>Excel Import</h2>
//         <p>Upload an Excel file to import employee leave data</p>
//       </div>
//       <div 
//         style={{ 
//           border: '2px dashed #d9d9d9', 
//           borderRadius: '8px', 
//           padding: '40px', 
//           margin: '0 auto',
//           maxWidth: '500px',
//           backgroundColor: '#fafafa'
//         }}
//       >
//         <p>Drag and drop your Excel file here or</p>
//         <button 
//           style={{
//             backgroundColor: '#1890ff',
//             color: 'white',
//             border: 'none',
//             padding: '10px 20px',
//             borderRadius: '4px',
//             cursor: 'pointer',
//             fontSize: '16px'
//           }}
//         >
//           Browse Files
//         </button>
//       </div>
//       <div style={{ marginTop: '20px', color: '#8c8c8c' }}>
//         <p>Supported formats: .xlsx, .xls, .csv</p>
//       </div>
//     </div>
//   );
// };

const UserRole = () => {
  const [activeTab, setActiveTab] = useState("1");

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Employee Leave</Breadcrumb.Item>
        <Breadcrumb.Item>
          {activeTab === "1" ? "All Leaves" : "Import Data"}
        </Breadcrumb.Item>
      </Breadcrumb>
      
      <div className="site-layout-content">
        <Tabs 
          defaultActiveKey="1" 
          onChange={handleTabChange}
          type="card"
        >
          <TabPane
            tab={
              <span>
                <UnorderedListOutlined />
                Employee Leaves
              </span>
            }
            key="1"
          >
            <Maincontent />
          </TabPane>
          <TabPane
            tab={
              <span>
                <FileExcelOutlined />
                Excel Import
              </span>
            }
            key="2"
          >
            <ExcelImport />
          </TabPane>
        </Tabs>
      </div>
    </>
  );
};

export default connect()(UserRole);